import { render } from "./Attendances.vue?vue&type=template&id=e4801304"
import script from "./Attendances.vue?vue&type=script&lang=js"
export * from "./Attendances.vue?vue&type=script&lang=js"

import exportComponent from "/Users/elliot/Documents/attendance-systems/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__